import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneNumberInput = ({ value, onChange, error, country }) => {
  return (
    <div>
      <PhoneInput
        country={country}
        value={value}
        onChange={onChange}
        inputStyle={{ width: "100%", backgroundColor: "transparent" }}
        inputProps={{
          name: "phone",
          required: true,
        }}
        autoComplete="off"
      />
    </div>
  );
};

export default PhoneNumberInput;
